import { render, staticRenderFns } from "./UiEvent.vue?vue&type=template&id=0e32f8ea&lang=pug&"
import script from "./UiEvent.vue?vue&type=script&lang=js&"
export * from "./UiEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports